import { setHeaderDataToState } from '@/utils/helpers/getHeaderData'

export default function setHeaderDataToStateAfterEach({ store }) {
  if (!process.client) return

  setHeaderDataToState({ store })
}
